<div class="container">
  <img width="56" height="56" ngSrc="/assets/img/icons/api-round.svg" alt="" priority />
  <mat-progress-bar mode="buffer" class="custom-progress-bar"></mat-progress-bar>
  <div class="success">
    <img width="40" height="40" ngSrc="/assets/img/icons/success-disabled.svg" alt="" priority />
  </div>
</div>
